/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../../Shared/components/Previous";
import customStyles from "../../../../../assets/styles/customStyles";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import MainHeader from "../../../../Shared/components/Header";
import clsx from "clsx";
import { ListTable } from './ListTable';
import crudActions from "../../../../CRUD/redux/actions";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { NavLink } from "react-router-dom";
import unitActions from "../../../../Product/Setup/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import actions from "../../redux/actions";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { toast } from 'react-toastify';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Row, Col, Image, Space } from "antd";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { Button, TextField, Box, Typography } from "@mui/material";
import { useEventListener } from "../../../../../helpers/useEventListener";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const Group = (props) => {
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [addMore, setAddMore] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { productGroupDetails, productGroupLoader } = useSelector(state => state.productSetupReducer);
    const { history } = props;
    const { editDetails, editError, editLoader, createDetails, createError, createLoader } = useSelector(state => state.crudReducer);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [deleteModal, setDeleteModal] = useState(false);
    const [error, setError] = useState({});
    const [form, setForm] = useState({});
    const [view, setView] = useState(false);
    const [visible, setVisible] = useState(false);
    const [groupId, setGroupId] = useState('');
    const dispatch = useDispatch();
    const [importVisible, setImportVisible] = useState(false);

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const handleOpen = () => {
        setGroupId('');
        setVisible(true);
        setError({}); setForm({});
    }

    const onExport = () => {
        loadImportExportData('Product Group');
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.PRODUCT_GROUP_DETAILS_START,
            url: 'product-groups',
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id desc',
            }
        });
    });

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    }

    const emptyState = () => {
        setError({});
    }
    const emptyStateInput = () => {
        setForm({
            "name": '',
            "description": ''
        });
    };

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 78) {
            e.preventDefault();
            setVisible(true);
        } else if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            createProductGroup(e);
        }
    }
    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const handleAddMore = (e) => {
        createProductGroup(e);
        setAddMore(true);
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            // toast(`"${createData.name}" has been added successfully`);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            setError({
                ...error,
                "name": text
            })
        }
    }, [createDetails, createError]);


    const createProductGroup = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('Name', form.name);
        emptyState();
        if (emptyName.isValid) {
            // let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v != null && v != ''));
            Object.keys(form).forEach(k => !Number.isInteger(form[k]) && (form[k] = form[k].trim()));
            dispatch({
                type: groupId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: "product-groups",
                title: "Product Group",
                id: groupId,
                details: form,
                //method: groupId ? 'put' : ''
            })
        } else {
            setError({
                'name': emptyName.errors
            });
        }
    }


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            // toast(`"${form.name}" has been updated successfully`);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            setError({
                ...error,
                "name": text
            })
        }
    }, [editDetails, editError]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Product Group', history, 'Product')) {
                loadTasks();
            }
        }
        return () => {
            dispatch({
                type: actions.CLEAR_PRODUCT_DETAILS_START,
            });
        };
    }, [roleManagement]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'product-groups',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const handleOpenImport = () => {
        setImportVisible(true);
    }

    const changeHandler = (e, name = '') => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const handleAdd = () => {
        setView(false);
        handleOpen();
    }

    const onEdit = (data) => {
        setView(false);
        handleOpen();
        setGroupId(data.id);
        setForm({
            "name": data?.name,
            "description": data?.description !== null && data?.description !== '' ? data?.description : ''
        });
    }

    const onView = (data) => {
        setView(true);
        handleOpen();
        setGroupId(data.id);
        setForm({
            "name": data?.name,
            "description": data?.description !== null && data?.description !== '' ? data?.description : ''
        });
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setGroupId(data.id);
        setForm(data);
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={'Product'} links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'Product Group', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Product Group'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Product Group', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Group and Description'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                id={idNamingConversion('Search', 'productGroup', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center" >
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Product Group', 'create', 'Product') &&
                                                <NavLink
                                                    to={"#"}
                                                    id={idNamingConversion('Add Product Group', 'productGroup', 'Link')}
                                                    onClick={() => handleAdd()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Product Group</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Product Group', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'productGroup', 'Link')}
                                                    onClick={() => onExport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Product Group', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpenImport()}
                                                    className={clsx(classes.customLink)}
                                                    id={idNamingConversion('Import', 'productGroup', 'Link')}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                onEdit={(data) => onEdit(data)}
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                handleOpen={() => handleOpen()}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                onView={(data) => onView(data)}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={`${groupId ? `${view ? 'View' : 'Edit'}` : 'Add'} Product Group`}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"

                        onSubmit={(e) => createProductGroup(e)}>
                        <div className={classes.customFormFlex}>
                            <Row type="flex">
                                <Col span={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Name</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.name || '---'}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={["Name ", <span key={"Name"} className={classes.colorRedRequired}> *</span>]}
                                                variant={'standard'}
                                                className={''}
                                                error={error.name ? true : false}
                                                helperText={error.name}
                                                name={"name"}
                                                fullWidth
                                                id={idNamingConversion('Name', 'productGroup', 'TextField')}
                                                value={form.name}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.description || '---'}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={["Description "]}
                                                name={"description"}
                                                value={form?.description}
                                                fullWidth={true}
                                                id={idNamingConversion('Description', 'productGroup', 'TextField')}
                                                multiline
                                                variant="outlined"
                                                className={clsx(classes.margin30t, classes.customDescription)}
                                                rows={4}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColor,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            {
                                <Space size={[10, 10]} direction="horizontal" align="center">
                                    {
                                        !view ? <> <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                groupId ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                            {
                                                !groupId &&
                                                <Button
                                                    key="Add More"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={(e) => handleAddMore(e)}
                                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                                >Add More</Button>
                                            }
                                        </> : <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => setView(false)}>Edit</NavLink>
                                    }
                                </Space>
                            }
                        </div>
                    </Box>
                }
            />
            <ImportExport
                handleClose={() => handleImportClose()}
                visible={importVisible}
                title={'Product Group'}
                type={"import"}
                details={productGroupDetails}
                loader={productGroupLoader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder); }}
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={groupId} loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                name={form.name} url={'product-groups'}
                title={'Product Group'} visible={deleteModal} />
        </React.Fragment>
    )
}

export default Group
